import { constant } from './ContextualHelpActionsConstant'
import { APIDirectory, HTTP } from '../../rest'
/**
 * get userProfile list is triggered
 */
export const contextualHelpFetchInProgress = () => {
  // l;
  return {
    type: constant.CONTEXTUAL_HELP_FETCH_IN_PROGRESS
  }
}

export const contextualHelpFetchComplete = (contextualHelp) => {
  return {
    type: constant.CONTEXTUAL_HELP_FETCH_COMPLETE,
    data: contextualHelp

  }
}

export const getContextualHelp = () => {
  return async dispatch => {
    try {
      dispatch(contextualHelpFetchInProgress());
      let contextualHelp = await HTTP.GET(APIDirectory.getcontextualHelpURL());
      if (contextualHelp !== null) {
        dispatch(contextualHelpFetchComplete(contextualHelp));
        return contextualHelp;
      }
    } catch (error) {
      return [];
    }
  };
}

